<template>
  <div id="myPage">
    <div v-if="isRender" class="container">
      <div class="row">
        <div class="col-md-offset-3 col-sm-offset-2 col-md-6 col-sm-8 col-xs-12">
          <ul class="row nav nav-tabs">
            <li :class="['col-xs-4', {'active': currentTab === 'information'}]">
              <a href="#" @click.prevent="currentTab = 'information'">정보수정</a>
            </li>
            <li :class="['col-xs-4', {'active': currentTab === 'security'}]">
              <a href="#" @click.prevent="currentTab = 'security'">보안</a>
            </li>
          </ul>
          <div class="tab-content">
            <form id="information" v-show="currentTab === 'information'" @submit.prevent="onSubmit('info')">
              <div class="row form-group">
                <div class="col-md-4 col-xs-12">
                  <label>아이디</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <input type="text"
                         class="hz-input-default hz-input-lg"
                         v-model="userInfo['username']"
                         readonly="readonly">
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4 col-xs-12">
                  <label>비밀번호</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <a href="javascript:void(0);" style=" display: block; line-height: 48px;"
                     @click="currentTab = 'security'">변경하기</a>
                </div>
              </div>
              <div class="division-line"></div>
              <div class="row form-group">
                <div class="col-md-4 col-xs-12">
                  <label>회사명</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <input type="text"
                         class="hz-input-default hz-input-lg"
                         v-model="userInfo['comp_name']"
                         readonly="readonly">
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4 col-xs-12">
                  <label>사업자 등록번호</label>
                </div>
                <div class="col-md-8 col-xs-12" style="position: relative;">
                  <input type="text"
                         class="hz-input-default hz-input-lg"
                         maxlength="20"
                         data-vv-name="crn"
                         v-validate="{required: true, min: 10, max: 12, regex: '^[0-9]{3}-[0-9]{2}-[0-9]{5}'}"
                         v-model="userInfo['crn']" placeholder="000-00-00000"
                         v-mask="'###-##-#####'">
                  <p class="is-invalid-text">{{ errors.first('crn') }}</p>
                  <!--i v-if="hasLicense"
                     class="glyphicon glyphicon-download-alt"
                     @click="onDownload(data.license_file[0].datafile)"
                     style="position: absolute; top: 16px; right: 16px; font-size: 16px; cursor: pointer;"></i-->
                </div>
              </div>
              <!-- 가입 시 사업자등록증을 업로드 안했을 경우에만 활성화 -->
              <!--div v-if="!hasLicense" class="row form-group"-->
              <div class="row form-group margin-bottom-32">
                <div class="col-md-4">
                  <label>사업자등록증</label>
                </div>
                <div class="col-md-8">
                  <input-file :autoUpload="true"
                              :options="licenseUploadOption"
                              :saveUrl="fileSaveUrl + '?category=license_file'"
                              :removeUrl="fileRemoveUrl"
                              v-model="userInfo['license_file']"></input-file>
                  <p class="explain-text">pdf, jpg, png 파일(5MB이하)로 업로드 후 아래 수정하기 버튼을 눌러주세요.</p>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4 col-xs-12">
                  <label>회사주소</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <input-address type="text"
                                 class="col-xs-12 hz-address-default padding-0"
                                 data-vv-name="address"
                                 v-validate="{required: true, max: 255}"
                                 v-model="userInfo['address']"
                                 placeholder="회사주소">
                  </input-address>
                  <input type="text"
                         class="hz-input-default hz-input-lg margin-top-8"
                         maxlength="100"
                         v-model="userInfo['rest_address']"
                         placeholder="상세주소">
                  <p class="is-invalid-text">{{ errors.first('address') }}</p>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4 col-xs-12">
                  <label>회사연락처</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <input-phone :class="['hz-input-default', 'hz-input-lg', {'is-invalid': errors.first('company_contact')}]"
                               data-vv-name="company_contact"
                               v-validate="{required: true, min:9, max:16}"
                               v-model="userInfo['contact']"></input-phone>
                  <p class="is-invalid-text">{{ errors.first('company_contact') }}</p>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4 col-xs-12">
                  <label>팩스</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <input-phone :class="['hz-input-default', 'hz-input-lg', {'is-invalid': errors.first('fax')}]"
                               data-vv-name="fax"
                               v-validate="{min:9, max:16}"
                               v-model="userInfo['fax']"></input-phone>
                  <p class="is-invalid-text">{{ errors.first('fax') }}</p>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4 col-xs-12">
                  <label>세금계산서 이메일</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <input type="text"
                         class="hz-input-default hz-input-lg"
                         maxlength="50"
                         data-vv-name="tax_email"
                         v-validate="{email: true}"
                         v-model="userInfo['tax_email']">
                  <p class="is-invalid-text">{{ errors.first('tax_email') }}</p>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4 col-xs-12">
                  <label>전기공사업 면허</label>
                </div>
                <div class="col-md-8 col-xs-12" style="line-height: 48px;">
                  <label class="hz-radio-btn radio-inline" style="margin-right: 16px;">
                    <input type="radio"
                           :value="false"
                           v-model="userInfo['electronic_license']">없음
                  </label>
                  <label class="hz-radio-btn radio-inline">
                    <input type="radio"
                           :value="true"
                           v-model="userInfo['electronic_license']">있음
                  </label>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4 col-xs-12">
                  <label>로고등록</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <input-file :autoUpload="true"
                              :options="logoUploadOption"
                              :saveUrl="fileSaveUrl + '?category=logo'"
                              :removeUrl="fileRemoveUrl"
                              :preview="true"
                              :rotate="true"
                              v-model="userInfo['logo_file']"></input-file>
                  <p class="explain-text">jpg, png 파일(5MB이하)로 업로드 후 아래 수정하기 버튼을 눌러주세요.</p>
                </div>
              </div>
              <div id="companyIntroduction" class="row form-group">
                <div class="col-md-4 col-xs-12">
                  <label>회사소개서</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <input-file :autoUpload="true"
                              :options="resumeUploadOption"
                              :saveUrl="fileSaveUrl + '?category=resume'"
                              :removeUrl="fileRemoveUrl"
                              :preview="true"
                              :rotate="true"
                              v-model="userInfo['resume_file']"></input-file>
                  <p class="explain-text">jpg, png 파일(5MB이하)로 업로드 후 아래 수정하기 버튼을 눌러주세요.</p>
                </div>
              </div>
              <div class="division-line"></div>
              <div class="row form-group">
                <div class="col-md-4 col-xs-12">
                  <label>담당자명</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <input type="text"
                         class="hz-input-default hz-input-lg"
                         maxlength="20"
                         data-vv-name="name"
                         v-validate="{required: true}"
                         v-model="userInfo['pic_name']">
                  <p class="is-invalid-text">{{ errors.first('name') }}</p>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4 col-xs-12">
                  <label>담당자 연락처</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <input-phone :class="['hz-input-default', 'hz-input-lg', {'is-invalid': errors.first('pic_contact')}]"
                               data-vv-name="contact"
                               v-validate="{required: true, min:9, max:16}"
                               v-model="userInfo['pic_contact']"></input-phone>
                  <p class="is-invalid-text">{{ errors.first('contact') }}</p>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4 col-xs-12">
                  <label>담당자 이메일</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <input type="text"
                         class="hz-input-default hz-input-lg"
                         maxlength="50"
                         data-vv-name="email"
                         v-validate="{required: true, email: true}"
                         v-model="userInfo['pic_email']">
                  <p class="is-invalid-text">{{ errors.first('email') }}</p>
                </div>
              </div>
              <div class="division-line"></div>
              <div class="row form-group">
                <div class="col-md-4 col-xs-12">
                  <label>사업분야</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <input type="text"
                         class="hz-input-default hz-input-lg"
                         v-model="userInfo['category']"
                         readonly="readonly">
                  <div class="margin-top-8">
                    <label v-for="category in categoryList" class="hz-checkbox">
                      {{ category.name }}
                      <input type="checkbox" :value="category.value" v-model="userInfo['category']">
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4 col-xs-12">
                  <label>협력희망분야</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <input type="text"
                         class="hz-input-default hz-input-lg"
                         v-model="userInfo['interest_service']"
                         readonly="readonly">
                  <div class="margin-top-8">
                    <label v-for="interest in interestList" class="hz-checkbox">
                      {{ interest.name }}
                      <input type="checkbox" :value="interest.value" v-model="userInfo['interest_service']">
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="row form-group margin-bottom-40">
                <div class="col-md-4 col-xs-12">
                  <label>마케팅 동의</label>
                </div>
                <div class="col-md-8 col-xs-12" style="line-height: 48px;">
                  <label class="hz-radio-btn radio-inline" style="margin-right: 16px;">
                    <input type="radio"
                           :value="true"
                           v-model="userInfo['agree_promotion']">동의
                  </label>
                  <label class="hz-radio-btn radio-inline">
                    <input type="radio"
                           :value="false"
                           v-model="userInfo['agree_promotion']">미동의
                  </label>
                </div>
              </div>
              <button type="submit" class="hz-btn-primary hz-btn-lg padding-0 col-md-offset-8 col-md-4 col-xs-12">수정하기</button>
            </form>
            <form id="security" v-show="currentTab === 'security'" @submit.prevent="onSubmit('password')">
              <div class="row form-group margin-bottom-32">
                <div class="col-md-4 col-xs-12">
                  <label>현재 비밀번호</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <input type="password"
                         class="hz-input-default hz-input-lg"
                         maxlength="40"
                         data-vv-name="password"
                         v-validate="{required: true}"
                         v-model="userInfo['old_password']">
                  <p v-if="errors.first('password')" class="is-invalid-text">{{ errors.first('password') }}</p>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4 col-xs-12">
                  <label>변경 비밀번호</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <input type="password" ref="new_password"
                         class="hz-input-default hz-input-lg"
                         maxlength="15"
                         data-vv-name="new_password"
                         v-validate="{required: true, min: 8, max: 15, regex: '^(?=.*[a-z]|.*[A-Z])(?=.*\\d)[a-zA-Z\\d]'}"
                         v-model="userInfo['new_password']">
                  <p v-if="errors.first('new_password')" class="is-invalid-text">{{ errors.first('new_password') }}</p>
                  <p class="explain-text">문자와 숫자조합으로 8자 이상 15자 이하로 입력해주세요.</p>
                </div>
              </div>
              <div class="row form-group margin-bottom-40">
                <div class="col-md-4 col-xs-12">
                  <label>변경 비밀번호 확인</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <input type="password"
                         class="hz-input-default hz-input-lg"
                         maxlength="15"
                         data-vv-name="new_password2"
                         v-validate="{required: true, confirmed: 'new_password'}"
                         v-model="userInfo['new_password2']">
                  <p v-if="errors.first('new_password2')" class="is-invalid-text">{{ errors.first('new_password2') }}</p>
                </div>
              </div>
              <button type="submit" class="hz-btn-primary hz-btn-lg padding-0 col-md-offset-8 col-md-4 col-xs-12">변경하기</button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- 로더 -->
    <loader v-if="!isRender || loaderActive"></loader>
    <!-- 알림창 -->
    <modal ref="notifyModal" :id="notifyModal.id" :type="notifyModal.type" :title="notifyModal.title"
           :size="notifyModal.size" :fields="notifyModal.fields"></modal>
    <!-- 사업자번호 수정창 -->
    <modal ref="updateCrnModal" :id="updateCrnModal.id" :type="updateCrnModal.type" :title="updateCrnModal.title"
           :size="updateCrnModal.size" :fields="updateCrnModal.fields" @submit="updateUserInfo()"></modal>
    <!-- 기본정보 수정창 -->
    <modal ref="updateInfoModal" :id="updateInfoModal.id" :type="updateInfoModal.type" :title="updateInfoModal.title"
           :size="updateInfoModal.size" :fields="updateInfoModal.fields" @submit="updateUserInfo()"></modal>
    <!-- 패스워드 수정창 -->
    <modal ref="updatePasswordModal" :id="updatePasswordModal.id" :type="updatePasswordModal.type" :title="updatePasswordModal.title"
           :size="updatePasswordModal.size" :fields="updatePasswordModal.fields" @submit="updatePassword()"></modal>
  </div>
</template>

<script>
  import Loader from 'common/components/Loader'
  import InputField from 'common/components/InputText'
  import InputFile from 'common/components/InputFile'
  import InputPhone from 'common/components/InputPhone'
  import InputAddress from 'common/components/InputAddress'
  import KendoGrid from 'common/components/KendoGrid'
  import Modal from 'common/components/Modal'
  import { mapActions, mapGetters } from 'vuex'
  import api from '@/api/user'

  export default {
    name: 'mypage',
    components: {Loader, InputField, InputFile, InputPhone, InputAddress, KendoGrid, Modal},
    data () {
      return {
        isRender: false,
        loaderActive: false,
        hasLicense: false,
        currentTab: 'information',
        baseUrl: location.protocol + '//' + location.hostname.replace('biz', 'api'),
        userInfo: {
          id: '',
          username: '',
          old_password: '',
          new_password: '',
          new_password2: '',
          name: '',
          crn: '',
          origin_crn: '',
          license_file: [],
          address: '',
          rest_address: '',
          contact: '', // 회사연락처
          fax: '',
          tax_email: '',
          electronic_license: false,
          pic_name: '',
          pic_contact: '', // 담당자 연락처
          pic_email: '',
          logo_file: [],
          resume_file: [],
          category: [],
          interest_service: [],
          agree_promotion: false
        },
        categoryList: [
          { name: '공사(구조물)', value: '공사(구조물)' },
          { name: '공사(전기)', value: '공사(전기)' },
          { name: '인허가', value: '인허가' },
          { name: '제조(모듈)', value: '제조(모듈)' },
          { name: '제조(인버터)', value: '제조(인버터)' },
          { name: '제조(수배전반)', value: '제조(수배전반)' },
          { name: '기타', value: '기타' }
        ],
        interestList: [
          { name: '사업개발', value: '사업개발' },
          { name: '주택시공', value: '주택시공' },
          { name: '아파트시공', value: '아파트시공' },
          { name: 'RPS시공', value: 'RPS시공' },
          { name: '영업', value: '영업' },
          { name: '모듈/인버터구입', value: '모듈/인버터구입' },
          { name: '제안서제작', value: '제안서제작' },
          { name: '금융', value: '금융' },
          { name: '기타', value: '기타' }
        ],
        licenseUploadOption: {
          validation: {
            allowedExtensions: ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png'],
            maxFileSize: 5 * 1024 * 1024,
            minFileSize: 0
          }
        },
        logoUploadOption: {
          validation: {
            allowedExtensions: ['.jpg', '.jpeg', '.png'],
            maxFileSize: 5 * 1024 * 1024,
            minFileSize: 0
          }
        },
        resumeUploadOption: {
          validation: {
            allowedExtensions: ['.jpg', '.jpeg', '.png'],
            maxFileSize: 5 * 1024 * 1024,
            minFileSize: 0
          }
        },
        fileSaveUrl: location.protocol + '//' + location.hostname.replace('biz', 'api') + '/biz/company/file/',
        fileRemoveUrl: location.protocol + '//' + location.hostname.replace('biz', 'api') + '/biz/company/file/delete/',
        notifyModal: {
          id: 'notifyModal',
          type: 'alert',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['입력정보를 확인해주세요.'],
              class: 'text-center'
            }
          ]
        },
        updateCrnModal: {
          id: 'updateCrnModal',
          type: 'confirm',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['사업자번호를 수정할 경우, 회원등급이 비인증회원으로 수정되고 관리자 확인 후 복구됩니다. 계속하시겠습니까?'],
              class: 'text-center'
            }
          ]
        },
        updateInfoModal: {
          id: 'updateInfoModal',
          type: 'confirm',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['기본정보를 수정하시겠습니까?'],
              class: 'text-center'
            }
          ]
        },
        updatePasswordModal: {
          id: 'updatePasswordModal',
          type: 'confirm',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['비밀번호를 변경하시겠습니까?'],
              class: 'text-center'
            }
          ]
        }
      }
    },
    computed: {
      ...mapGetters({
        user: 'user'
      })
    },
    watch: {
      'user': {
        handler: function () {
          // 로그인한 유저에 ID가 있을 경우, 유저 정보를 불러온다.
          if (this.user.id) {
            this.getUser()
          }
        },
        deep: true
      },
      'currentTab': {
        handler: function () {
          // validation 오류 목록을 초기화 한다.
          this.errors.clear()
        }
      }
    },
    methods: {
      ...mapActions([
        'showToastMessage'
      ]),
      init: function (data = null) {
        const vm = this
        const obj = this.userInfo
        // 해줌 사용자에 경우 company 데이터가 없으므로 기본 사용자 정보를 넣어준다.
        const info = data === null ? vm.user : data

        // 사용자 정보가 있을 경우
        if (data) {
          obj.id = info.id
          obj.username = vm.user.username
          obj.comp_name = info.name
          obj.crn = info.crn
          obj.origin_crn = info.crn
          obj.license_file = (info.license_file !== '' && info.license_file.length > 0) ? info.license_file : []
          obj.address = info.address
          obj.rest_address = info.rest_address
          obj.contact = info.contact
          obj.fax = info.fax
          obj.tax_email = info.tax_email
          obj.electronic_license = info.electronic_license
          obj.pic_name = info.pic_name
          obj.pic_contact = info.pic_contact
          obj.pic_email = info.pic_email
          obj.logo_file = (info.logo_file !== '' && info.logo_file.length > 0) ? info.logo_file : []
          obj.resume_file = (info.resume_file !== '' && info.resume_file.length > 0) ? info.resume_file : []
          obj.category = (info.category === null || info.category === '') ? [] : info.category.split(',')
          obj.interest_service = (info.interest_service === null || info.interest_service === '') ? [] : info.interest_service.split(',')
          obj.agree_promotion = vm.user.agree_promotion

          // 회원가입 시 사업자 등록증 업로드 여부에 대한 플래그 초기화
          vm.hasLicense = info.license_file !== '' && info.license_file.length > 0
        } else {
          // 사용자 정보가 없을 경우
          obj.id = info.id
          obj.username = info.username
          obj.comp_name = info.comp_name
          obj.crn = info.crn
          obj.origin_crn = info.crn
          obj.address = info.address
          obj.contact = info.contact
          obj.fax = info.fax
          obj.pic_name = info.pic_name
          obj.pic_contact = info.pic_contact
          obj.pic_email = info.pic_email
          obj.agree_promotion = vm.user.agree_promotion
        }

        // 데이터 초기화
        Object.assign(vm.userInfo, obj)

        // 화면 Render
        vm.isRender = true
      },
      getUser: function () {
        const vm = this

        // 로그인한 유저에 정보를 불러온다.
        api.getUser(vm.user.id, response => {
          if (response.error) {
            // API 호출 실패 시
            vm.showToastMessage('사용자정보 불러오기 실패')
            console.log('get UserInfo fail!', response)
          } else {
            vm.init(response.companyprofile)
          }
        })
      },
      onSubmit: function (type) {
        const vm = this
        const infoArr = ['name', 'contact', 'email', 'address', 'company_contact']
        const passwordArr = ['password', 'new_password', 'new_password2']
        let validArr = type === 'info' ? infoArr : passwordArr

        // 현재 선택된 탭에 맞는 필드만 검증
        for (let i in validArr) {
          vm.$validator.validate(validArr[i])
        }

        vm.$nextTick(function () {
          // 폼에 대한 유효성검증이 끝났을 경우
          if (!vm.errors.any()) {
            if (type === 'info') {
              if (this.checkBisNo(this.userInfo.crn)) {
                if (this.userInfo.origin_crn !== this.userInfo.crn) {
                  vm.$refs.updateCrnModal.show()
                } else {
                  // 기본정보 수정여부에 대한 알림창을 띄운다.
                  vm.$refs.updateInfoModal.show()
                }
              }
            } else {
              // 패스워드 수정여부에 대한 알림창을 띄운다.
              vm.$refs.updatePasswordModal.show()
            }
          } else {
            // 유효성검증에 실패 했을 경우, 알림창을 띄운다.
            vm.$refs.notifyModal.show()
          }
        })
      },
      onDownload: function (url) {
        // 이미지 파일에 url을 연다.
        if (url) {
          window.open(url, '_blank').focus()
        }
      },
      updateUserInfo: function () {
        const vm = this
        const info = vm.userInfo
        const licenseFile = (info.license_file !== '' && info.license_file.length > 0) ? JSON.stringify(info.license_file) : ''
        const logoFile = (info.logo_file !== '' && info.logo_file.length > 0) ? JSON.stringify(info.logo_file) : ''
        const resumeFile = (info.resume_file !== '' && info.resume_file.length > 0) ? JSON.stringify(info.resume_file) : ''
        const data = {
          id: vm.user.id,
          crn: info.crn,
          address: info.address,
          rest_address: info.rest_address,
          contact: info.contact, // 회사연락처
          fax: info.fax,
          tax_email: info.tax_email,
          electronic_license: info.electronic_license,
          pic_name: info.pic_name,
          pic_contact: info.pic_contact, // 담당자 연락처
          pic_email: info.pic_email,
          license_file: licenseFile,
          logo_file: logoFile,
          resume_file: resumeFile,
          category: info.category.length > 0 ? info['category'].toString() : '',
          interest_service: info.interest_service.length > 0 ? info['interest_service'].toString() : '',
          agree_promotion: info.agree_promotion
        }

        // 로더 활성화
        vm.loaderActive = true

        // 기본정보를 업데이트 한다.
        api.updateUserInfo(data, response => {
          if (response.error) {
            vm.loaderActive = false
            vm.showToastMessage('회원정보 수정실패 (' + response.response.data.message + ')')
            // API 호출 실패 시
            console.log(response.message)
          } else {
            const token = localStorage.getItem('_t')

            // 수정된 회원정보를 불러와 vuex store에 유저정보를 업데이트 해준다.
            vm.$store.dispatch('getUserInfo', token).then(response => {
            }).catch(error => {
              // 유효하지 않은 토큰일 경우 로그아웃 처리한다.
              vm.$store.commit('LOGOUT')
              console.log('get UserInfo Error!', error)
            })

            // 로더 비활성화
            vm.loaderActive = false

            // 회원정보 수정완료 메세지 출력
            vm.showToastMessage('회원정보 수정완료')
          }
        })
      },
      updatePassword: function () {
        const vm = this
        const data = {
          id: vm.user.id,
          old_password: vm.userInfo.old_password,
          new_password: vm.userInfo.new_password
        }

        // 로더 활성화
        vm.loaderActive = true

        // 비밀번호를 업데이트 한다.
        api.updatePassword(data, response => {
          if (response.error) {
            // API 호출 실패 시
            vm.loaderActive = false
            alert('현재 비밀번호를 다시 확인해주세요.')
            console.log('fail updatePassword', response)
          } else {
            // 필드 초기화
            vm.userInfo.old_password = ''
            vm.userInfo.new_password = ''
            vm.userInfo.new_password2 = ''
            vm.showToastMessage('비밀번호 수정완료')

            // 로더 비활성화
            vm.loaderActive = false
          }
        })
      },
      checkBisNo: function (val) {
        // bisNo는 숫자만 10자리로 해서 문자열로 넘긴다.
        const vm = this
        const bisNo = val.replace(/-/gi, '')
        const checkID = [1, 3, 7, 1, 3, 7, 1, 3, 5, 1]
        let chkSum = 0

        for (let i = 0; i <= 7; i++) chkSum += checkID[i] * bisNo.charAt(i)
        let c2 = '0' + (checkID[8] * bisNo.charAt(8))
        c2 = c2.substring(c2.length - 2, c2.length)
        chkSum += Math.floor(c2.charAt(0)) + Math.floor(c2.charAt(1))
        let remander = (10 - (chkSum % 10)) % 10
        if (Math.floor(bisNo.charAt(9)) === remander) {
          return true
        } else {
          // 유효한 사업자 등록번호가 아닐 경우, 알림을 띄운다.
          vm.notifyModal.fields[0].message = ['사업자 등록번호를 다시 확인해주세요.']
          vm.$refs.notifyModal.show()
          return false
        }
      },
      setScrollPosition: function (id = '') {
        // 해당 ID를 가진 엘리먼트로 스크롤을 이동시킨다.
        if (id) {
          const body = $('body')
          const el = $('div[id="' + id + '"]')
          const innerWidth = body.innerWidth()

          // 현재 창의 크기에 따른 헤더의 높이를 계산하여 빼준다.
          let headerHeight = innerWidth > 991 ? 72 : 56
          let position = (body.scrollTop() + el.offset().top) - headerHeight

          if (el && typeof el !== 'undefined') {
            $('html,body').stop().animate({scrollTop: (position)}, 500)
          }
        }
      }
    },
    created: function () {
      const vm = this
      const token = localStorage.getItem('_t')

      // 토큰이 있을 경우, 토큰의 유호성을 검사한다.
      if (token) {
        // 검증된 토큰일 경우, 화면을 렌더 한다.
        vm.$store.dispatch('inspectToken', token).then((response) => {
          // 로그인한 유저에 ID가 있을 경우, 유저 정보를 불러온다.
          if (vm.user.id) {
            vm.getUser()
          }
        })
      } else {
        alert('로그인이 필요한 서비스입니다.')
        // 로그인이 안되있을 경우, 로그인 페이지로 redirect 처리.
        vm.$router.push({name: 'login'})
        vm.$route.query.next = {name: 'mypage'}
      }
    },
    beforeDestroy: function () {
      kendo.destroy(document.body)
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/components/tab';

  #myPage {
    .container {
      padding: 80px 0;
      @media (max-width: $screen-xs-max) {
        padding: 40px 8px;
      }
    }

    .tab-content {
      padding: 24px 0;
    }

    form {
      padding: 24px 0;

      .form-group {
        margin-bottom: 16px;

        .col-md-4 {
          padding: 0;

          >label {
            line-height: 48px;
            margin: 0;
            font-size: 14px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            letter-spacing: -0.8px;
            text-align: left;
            color: $font-color;

            @media (max-width: 767px) {
              line-height: 32px;
            }
          }
        }

        .col-md-8 {
          padding: 0;

          input {
            width: 100%;
          }

          .hz-radio-btn {
            font-weight: 400;
            color: #495057;

            >input {
              width: initial;
            }
          }
        }

        p {
          line-height: initial;
          margin: 2px 0 0 0;
        }
      }

      .division-line {
        width: 100%;
        margin: 40px 0;
        border-bottom: 1px solid $hzc-gray-03;

        @media (max-width: 767px) {
          margin: 16px 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/MyPage.vue